import { Link } from 'react-router-dom';

export default function NotFoundPage() {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen px-4 text-center gap-6 bg-background text-black">
      <h1 className="text-5xl font-bold">404 – Không tìm thấy trang</h1>
      <p className="text-xl">Hình như bạn đang cần một quyết định, nhưng đây không phải nơi đó!</p>

      <Link
        to="/"
        className="mt-4 px-6 py-3 bg-primary  text-white rounded-full hover:bg-secondary transition"
      >
        Để mình đưa bạn về nhé
      </Link>
    </div>
  );
}
